import { useMutation, useQueryClient } from '@tanstack/react-query'
import { reprocessCompumaticPunches } from 'api/admin/timeClock/reprocessCompumaticPunches'
import { timeClockKeys } from './keys'

export function useReprocessCompumaticPunchesMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: reprocessCompumaticPunches,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: timeClockKeys.all,
      })
    },
  })
}
